import React from "react";
import { useFormikContext } from "formik";
import { useSelectedIndexMaintainer } from "./useSelectedIndexMaintainer";
import { RadioGroup } from "../radioGroup";
import { useDefaultSelection } from "./useDefaultSelection";
import { usePendingPrefill, useSetDefaultValue } from "../../../hooks";
import { emptyFunction } from "../../../utils/helpers/emptyFunction";

export const PrefillRadioGroup = (props) => {
  const {
    name, title, placeholder, options, toolTipText, className, onBlur, combined, defaultValue = "", defaultSelectionIndex
  } = props;
  const { handleChange, handleBlur, values, errors, touched } = useFormikContext();
  useSelectedIndexMaintainer(options, name);
  useDefaultSelection(name, options, defaultSelectionIndex);

  useSetDefaultValue(name, defaultValue);
  usePendingPrefill(name);

  return (
    <RadioGroup
      title={title}
      placeholder={placeholder}
      onChange={handleChange}
      onBlur={(event) => {
        handleBlur(event);
        (onBlur || emptyFunction)(event);
      }}
      options={options}
      value={values[name]}
      name={name}
      combined={combined}
      toolTipText={toolTipText}
      className={className}
      errorMessage={touched[name] ? errors[name] : ""}
    />
  );
};